import { createFileRoute } from '@tanstack/react-router'

import { HodSiteDetailPage } from '@/systems/issues/features/hod-site-detail/components/HodSiteDetailPage'
import { hodSiteDetailQueryOptions } from '@/systems/issues/features/hod-site-detail/hooks/useHodSiteDetail'

// HOD's read-only site detail page. Backend opened /sites/{id}/details to
// HOD-of-site's-dept in Slice G (2026-05-12). Same payload admin gets;
// HOD's surface strips admin-only actions (edit, deactivate).
//
// Parent /hod route already auth-gates the subtree to role=hod, so no
// additional beforeLoad needed here.
export const Route = createFileRoute('/hod/sites/$siteId')({
  loader: ({ params, context: { queryClient } }) => {
    void queryClient.prefetchQuery(hodSiteDetailQueryOptions(params.siteId))
  },
  component: HodSiteDetailPage,
})
